import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { formatEur, formatPercent } from "../../lib/format-kpi";
import type { InvestmentListItem } from "../../lib/investments";

interface Props {
  items: InvestmentListItem[];
}

export function CardListDepot({ items }: Props) {
  const { t } = useTranslation();

  if (items.length === 0) {
    return (
      <p className="text-sm py-8 text-center" style={{ color: "var(--muted)" }}>
        {t("investments.list.empty", { defaultValue: "Keine Positionen" })}
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {items.map((p) => {
        const marketValue = p.calc.marketValueEur ?? 0;
        const marketValueCents = Math.round(marketValue * 100);
        const gainEur = p.calc.gainLossEur ?? null;
        const gainCents = gainEur !== null ? Math.round(gainEur * 100) : null;
        const gainPct = p.calc.gainLossPercent;

        return (
          <Link
            key={p.id}
            to={`/investments/${p.id}`}
            className="fv-card p-4 block active:opacity-80 transition-opacity"
          >
            <div className="font-medium truncate">{p.name}</div>
            <div className="text-xs mb-3" style={{ color: "var(--muted)" }}>
              {p.symbol || (p.isin ?? "—")} · {p.kind}
              {p.calc.stale && (
                <span
                  className="ml-2 px-1.5 py-0.5 rounded text-[10px]"
                  style={{ background: "var(--warn-soft)", color: "var(--warn)" }}
                >
                  stale
                </span>
              )}
            </div>
            <div className="flex justify-between text-sm mb-1">
              <span style={{ color: "var(--muted)" }}>
                {t("investments.column.value", { defaultValue: "Marktwert" })}
              </span>
              <span className="num font-semibold">
                {p.calc.marketValueEur !== null ? formatEur(marketValueCents) : "—"}
              </span>
            </div>
            <div className="flex justify-between text-sm">
              <span style={{ color: "var(--muted)" }}>
                {t("investments.column.gainLoss", { defaultValue: "Gewinn" })}
              </span>
              <span
                className="num font-semibold"
                style={{
                  color:
                    gainCents === null
                      ? "var(--muted)"
                      : gainCents >= 0
                        ? "var(--pos)"
                        : "var(--neg)",
                }}
              >
                {gainCents === null
                  ? "—"
                  : `${gainCents >= 0 ? "+" : ""}${formatEur(gainCents)}${
                      gainPct !== null
                        ? ` (${gainPct >= 0 ? "+" : ""}${formatPercent(gainPct)})`
                        : ""
                    }`}
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
